module.exports = __webpack_public_path__ + "202408221624/img/home_case_3.cab2d59a.jpg";